<template>
  <div class="pt-10">
    <video-list show-all-by-default local-storage-text-key="videos-search" local-storage-theme-key="videos-theme"/>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import VideoList from "@/components/video/videoList";

export default {
  name: "listVideos",
  components: { VideoList },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.$i18n.t('sidebar.videosMenu') }]);
  },
  metaInfo: {
    // Les enfants peuvent remplacer le titre.
    title: 'Vidéos',
    meta: [
      {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
      {name: 'viewport', content: 'width=device-width, initial-scale=1'},
      {name: 'description', content: 'Vidéos de l\'application TellMeGenius.'}
    ]
  }
};
</script>
